export enum LocaleEnum {
    Czech = 'cs',
    English = 'en',
    Ukrainian = 'uk',
}
